import { Locale } from './intl'
import { AppVariant } from './appVariant'

/** Separate Article IDs for sharing and tracking */
export const sharingArticleId: { [k in AppVariant]?: { [k in Locale]: string } } = {
  ballot: {
    de: '553456246692',
    fr: '16112831',
  },
  election: {
    de: '16281782',
    fr: '19421053',
  },
}

/** separate hashtags for sharing */
export const sharingHashtags: { [k in AppVariant]?: { [k in Locale]: string[] } } = {
  ballot: {
    de: ['CHvote'],
    fr: ['CHvote'],
  },
  election: {
    de: ['WahlCH19'],
    fr: ['EF2019'],
  },
}

export const gtmId = 'GTM-B35JQ84'
